// Module
var code = `<input
  required
  type="text"
  class="check-no"
  ng-model="\$ctrl.micrNumber"
  ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
  ui-mask-placeholder
  ui-options="{clearOnBlur: false}"
  ng-change="\$ctrl.updateNgModel()"
  maxlength="64"/>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/micr-number/micr-number.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;